import { useState } from "react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface JoinRequestLilyProps {
  request: {
    id: string;
    userName: string;
    createdAt: string;
  };
  onDragStart: (requestId: string) => void;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const JoinRequestLily = ({
  request,
  onDragStart,
  onClick,
  className,
  style,
}: JoinRequestLilyProps) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData("requestId", request.id);
    e.dataTransfer.effectAllowed = "move";
    setIsDragging(true);
    onDragStart(request.id);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            draggable
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onClick={onClick}
            className={cn(
              "cursor-grab active:cursor-grabbing",
              "transition-all duration-300",
              isDragging && "opacity-50 scale-110",
              className
            )}
            style={style}
          >
            {/* Water lily leaf */}
            <div className="relative w-16 h-16 sm:w-20 sm:h-20">
              <div
                className={cn(
                  "absolute inset-0 rounded-full",
                  "bg-gradient-to-br from-lily-pad via-lily-pad/90 to-lily-pad/70",
                  "border-2 border-lily-pad/50",
                  "shadow-lg hover:shadow-xl",
                  "transition-all duration-300 hover:scale-110"
                )}
              >
                {/* Leaf texture */}
                <div className="absolute inset-2 rounded-full border border-lily-pad/30" />
                <div className="absolute top-1/2 left-1/2 w-1 h-6 bg-lily-pad/40 transform -translate-x-1/2 -translate-y-1/2 rotate-45" />
              </div>
              
              {/* Egg on the lily */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl sm:text-3xl animate-pulse">
                🥚
              </div>
              
              {/* Notification badge */}
              <div className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-coral text-white text-xs flex items-center justify-center font-bold shadow-md">
                !
              </div>
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" className="bg-background/95 backdrop-blur">
          <p className="font-medium">{request.userName}</p>
          <p className="text-xs text-muted-foreground">Quer entrar na lagoa</p>
          <p className="text-xs text-coral mt-1">Arraste para dentro para aprovar</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
